import { TAB_ID } from '@frontend/tab-management';

type SoftphoneTabMessageType =
  | {
      type: 'SOFTPHONE_TAB';
      action: 'REGISTER' | 'UNREGISTER' | 'ACTIVATE';
      payload: {
        tabId: string;
      };
      source: string;
    }
  | {
      type: 'SOFTPHONE_TAB';
      action: 'CLEAR';
      source: string;
    };

type SoftphoneStateMessageType =
  | {
      type: 'SOFTPHONE';
      action: 'CONNECTED' | 'DISCONNECTED';
      payload: {
        tabId: string;
      };
    }
  | {
      type: 'SOFTPHONE';
      action: 'ACTIVE_CALL';
      payload: {
        tabId: string;
        hasActiveCall: boolean;
      };
    }
  | {
      type: 'SOFTPHONE';
      action: 'LAST_REGISTERED_CALL_ID';
      payload: {
        tabId: string;
        callId: string;
      };
    }
  | {
      type: 'SOFTPHONE';
      action: 'REGISTERED_SOFTPHONE';
      payload: {
        tabId: string;
        hasSoftphoneRegistered: boolean;
      };
    };

const unregisterTab = (tabId: string) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE_TAB',
      action: 'UNREGISTER',
      payload: {
        tabId,
      },
      source: TAB_ID,
    } satisfies SoftphoneTabMessageType);
  }
};

const registerTab = (tabId: string) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE_TAB',
      action: 'REGISTER',
      payload: {
        tabId,
      },
      source: TAB_ID,
    } satisfies SoftphoneTabMessageType);
  }
};

const activateTab = (tabId: string) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE_TAB',
      action: 'ACTIVATE',
      payload: {
        tabId,
      },
      source: TAB_ID,
    } satisfies SoftphoneTabMessageType);
  }
};

const activateCurrentTab = () => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE_TAB',
      action: 'ACTIVATE',
      payload: {
        tabId: TAB_ID,
      },
      source: TAB_ID,
    } satisfies SoftphoneTabMessageType);
  }
};

const clearTabStore = () => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE_TAB',
      action: 'CLEAR',
      source: TAB_ID,
    } satisfies SoftphoneTabMessageType);
  }
};

const broadcastConnected = (tabId: string) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE',
      action: 'CONNECTED',
      payload: {
        tabId,
      },
    } satisfies SoftphoneStateMessageType);
  }
};

const broadcastDisconnected = (tabId: string) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE',
      action: 'DISCONNECTED',
      payload: {
        tabId,
      },
    } satisfies SoftphoneStateMessageType);
  }
};

const broadcastActiveCall = (payload: { tabId: string; hasActiveCall: boolean }) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE',
      action: 'ACTIVE_CALL',
      payload,
    } satisfies SoftphoneStateMessageType);
  }
};

const broadcastLastRegisteredCallId = (payload: { tabId: string; callId: string }) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE',
      action: 'LAST_REGISTERED_CALL_ID',
      payload,
    } satisfies SoftphoneStateMessageType);
  }
};

const broadcastRegisterSoftphone = (payload: { tabId: string; hasSoftphoneRegistered: boolean }) => {
  if (navigator?.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SOFTPHONE',
      action: 'REGISTERED_SOFTPHONE',
      payload,
    } satisfies SoftphoneStateMessageType);
  }
};

export const SoftphoneStateWorkerInterface = {
  broadcastConnected,
  broadcastDisconnected,
  broadcastActiveCall,
  broadcastLastRegisteredCallId,
  broadcastRegisterSoftphone,

  registerTab,
  unregisterTab,
  activateTab,
  activateCurrentTab,
  clearTabStore,
};
